import * as React from "react";
import { Box } from "@mui/material";
import CclInfoTable from "../../../../components/common/cclInfoTable/cclInfoTable";
import { createMiscWorkSummaryTemplate, MiscWorkRecord } from "../miscWorkData";

export type SummaryProps = {
    record: MiscWorkRecord;
};

const Summary: React.FC<SummaryProps> = (props) => {
    return (
        <Box sx={{ width: 1, p: 3 }}>
            <CclInfoTable template={createMiscWorkSummaryTemplate()} data={props.record} readonly hideSave />
        </Box>
    );
};

export default Summary;